import React from 'react'

function Usluga() {
    return (
<section className="services" id="services">
  <div className="container">
    <div className="services-inner">
      <div className="services-title">
        <h1>СТОИМОСТЬ УСЛУГ ПО РАЗРАБОТКЕ САЙТОВ</h1>
      </div>
      <div className="our-services">
        <p>Наши услуги</p>
      </div>
      <div className="our-services-list">
        <h4>Услуги профессионального программиста</h4>
        <div className="our-services-price">
          <p>от <span className="round-log"> 10.000 </span> ₸</p>
          <button>СДЕЛАТЬ ЗАКАЗ</button>
        </div>
      </div>
      <div className="our-services-list">
        <h4>Услуги программиста для создание приложения </h4>
        <div className="our-services-price">
          <p> от <span className="round-loge"> 20.000 </span> ₸</p>
          <button>СДЕЛАТЬ ЗАКАЗ</button>
        </div>
      </div>
      <div className="our-services-list">
        <h4>Создание сайта сложных структур </h4>
        <div className="our-services-price">
          <p> от <span className="round-loges"> 30.000 </span> ₸</p>
          <button>СДЕЛАТЬ ЗАКАЗ</button>
        </div>
      </div>
      <div className="our-services-list">
        <h4>Проектные работы на профессиональном уровне</h4>
        <div className="our-services-price">
          <p> от <span className="round-logese"> 40.000 </span> ₸</p>
          <button>СДЕЛАТЬ ЗАКАЗ</button>
        </div>
      </div>
      </div>
    </div>
</section>

    )
}

export default Usluga
